import { render, staticRenderFns } from "./JIMNY5DOOR.vue?vue&type=template&id=68c30754&"
import script from "./JIMNY5DOOR.vue?vue&type=script&lang=ts&"
export * from "./JIMNY5DOOR.vue?vue&type=script&lang=ts&"
import style0 from "./JIMNY5DOOR.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports